<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="surgery_list"
            :url="url"
            :columns="columnList"
            :tableHeight="tableHeight"
            :buttons="[]"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            :selection="true"
            @selectionChange="checkedRow"
            @gotoSurgery="gotoSurgery"
            @deleteApply="deleteApply"
        >
            <slot slot="filter">
                <el-col :md="8" :xl="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input
                        type="string"
                        class="margin5 margin-none-h"
                        v-model="searchKey2"
                        :autofocus="true"
                        :placeholder="getPlaceholder"
                        :clearable="true"
                        @keyup.native.enter="loadSurgeries2"
                    ></item-input>
                </el-col>
                <!-- <el-col :md="8" :lg="5" :xl="5">
                    <item-input type="multiselect" v-model="surgery_status" :options="sys_enums && sys_enums.SurgeryStatus" :clearable="true" placeholder="手术状态"></item-input>
                </el-col> -->
                <el-col :span="4">
                    <item-input type="select" v-model="dic_room_id" :options="operationRoom" :clearable="true" placeholder="手术间"></item-input>
                </el-col>
            </slot>
            <template slot="filter-after">
                <el-button type="primary" v-if="IsHavePermission(`use_drug_apply_sync`)" size="mini" @click="runCarteServer">发送</el-button>
            </template>
            <template slot="patient_info" slot-scope="{ row }">
                <el-row>
                    <el-col :span="1" class="height-p100">
                        <div
                            class="surgery-status-tag"
                            :title="row.surgery_status"
                            :style="{ height: `90px` }"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                        >
                            &nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="23" class="padding5 padding-none-v align-left" :title="titleLabel(row)">
                        <div class="ellipsis" :title="`${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no || '--'}/${row.outpatient_no || '--'}/${row.bed_no || '--'}床)`">
                            <b>
                                <span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
                                {{ `${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no || '--'}/${row.outpatient_no || '--'}/${row.bed_no || '--'}床)` }}
                            </b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.surgeries }}</b>
                        </div>
                        <div v-if="!proc_GetTipItemsAnesthsia || proc_GetTipItemsAnesthsia == '0' || proc_GetTipItemsAnesthsia == ''">
                            <el-tag
                                :style="{ color: row.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C', borderColor: row.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C', backgroundColor: 'white' }"
                                size="mini"
                                >{{ row.surgery_type }}</el-tag
                            >
                            <el-tag
                                :style="{ color: row.enum_surgery_status >= 40 ? '#DFE2E7' : '#52b8d2', borderColor: row.enum_surgery_status == 40 ? '#DFE2E7' : '#52b8d2', backgroundColor: 'white' }"
                                size="mini"
                                >{{ row.enum_surgery_status > 10 ? '已排' : '待排' }}</el-tag
                            >
                            <el-tag style="color: #a0bb31; border-color: #a0bb31; background-color: white" size="mini">{{
                                row.enum_visit_type == 1 ? '住院' : row.enum_visit_type == 2 ? '门诊' : '体检'
                            }}</el-tag>
                            <el-tag :style="{ color: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', borderColor: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', backgroundColor: 'white' }" size="mini"
                                >日间</el-tag
                            >
                            <el-tag :style="{ color: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', borderColor: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', backgroundColor: 'white' }" size="mini"
                                >内镜</el-tag
                            >
                            <el-tag :style="{ color: row.is_local_anes ? '#5AA7B0' : '#DFE2E7', borderColor: row.is_local_anes ? '#5AA7B0' : '#DFE2E7', backgroundColor: 'white' }" size="mini"
                                >局麻</el-tag
                            >
                        </div>
                        <div v-else>
                            <el-tag v-for="item in row.patientInfoTipItemsList" :index="item.label" :key="item.label" :style="item.style" size="mini">{{ item.label }}</el-tag>
                        </div>
                    </el-col>
                </el-row>
            </template>
            <template slot="diseases" slot-scope="{ row }">
                <div style="width: 180px; white-space: normal">
                    <span>{{ row.diseases }}</span>
                </div>
            </template>
            <template slot="anaes_methods" slot-scope="{ row }"
                ><div style="width: 100px; white-space: normal">
                    <span>{{ row.anaes_methods }}</span>
                </div></template
            >
            <template slot="surgeon" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    (主)<span>{{ row.surgeon }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.surgeon_assistants }}</span>
                </div>
            </template>
            <template slot="plan_anes_doctor" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    <span>{{ row.plan_anes_doctor && `(主)${row.plan_anes_doctor.label}` || `--` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.plan_anes_assistants && row.plan_anes_assistants.map(d => d.label).join(',') }}</span>
                </div>
            </template>
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `UseDrugApply`,
    props: {

    },
    data() {
        return {
            title: `用药申请`,
            rdate: [this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)],
            searchKey: ``,
            searchKey2: ``,
            checkedRows: [],
            surgery_status: [20],
            dic_room_id: undefined,
            surgerSubStringRule: this.$root.SurgerSubStringRule,
            proc_GetTipItemsAnesthsia: this.$root.proc_GetTipItemsAnesthsia,
            useDrugApplyktr: this.$root.carte_UseDrugApply || `0`,
            url: {
                baseURL: `/api/AcisSystem/UseDrugApply`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        that.loadSurgeries(resolve, reject)
                    })
                }
            },
            windowsOpenLoop: ``
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `screenWidth`, `section_auth`, `currentUser`, `active_ward`, `sys_enums`, `business`, `permissions`, `localip/ipAddress`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        titleLabel() {
            return function(row) {
                let title = `患者:${row.patient_name} 性别:${row.sex || `--`} 年龄:${row.age || `--`} 
病例号:${row.visit_no || `--`} 
术前诊断:${row.diseases || `--`}
拟施手术:${row.surgeries || `--`}
${this.T(`Schedule.plan_surgeon`)}:${row.surgeon || `--`}
手术科室:${row.dic_section || `--`}
${this.T(`Schedule.plan_anes_doctor`)}:${row.plan_anes_doctor == null ? `` : row.plan_anes_doctor.label}
申请台次:${row.sequence || ``}
申请时间:${this.$moment(row.apply_time).format(`YYYY-MM-DD HH:mm:ss`)}
备注:${row.his_remark || ``}
传染病:${row.infectious || ``}
麻醉类型:${row.is_local_anes_val || ``}
`
                return title
            }
        },
        operationRoom() {
            return (
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            )
        },
        getPlaceholder() {
            return `请扫${this.T(`anesthesia_surgery_list.visit_no`)}`
        },
        columnList() {
            let me = this
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `custom`,
                    prop: `patient_info`,
                    label: `患者信息`,
                    width: `280`,
                    tooltip: false,
                    isListable: true
                },
                // {
                //     type: `string`,
                //     prop: `surgery_status`,
                //     label: `手术状态`,
                //     width: `100`,
                //     isListable: true
                // },
                {
                    type: `string`,
                    prop: `apply_status`,
                    label: `申请状态`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `130`,
                    isListable: true,
                    sortable: true,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `patient_abbr`,
                    label: `患者姓名简拼`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    width: `120`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `100`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `scheduled_sequence`,
                    label: `台次`,
                    width: `60`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `diseases`,
                    label: `诊断`,
                    width: `190`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `anaes_methods`,
                    label: `麻醉方式`,
                    width: `150`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划手术时间`,
                    width: `140`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `surgeon`,
                    label: this.T(`anesthesia_surgeries.plan_surgeon`),
                    width: `100`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `plan_anes_doctor`,
                    label: this.T(`anesthesia_surgeries.plan_anes_doctor`),
                    isListable: true,
                    width: `100`
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `120`,
                    fixed: `right`,
                    isListable: true,
                    readonly: false,
                    options: (that, { row }) => {
                        let btns = [{
                            class: `is-plain`,
                            label: `申请`,
                            icon: ``,
                            type: `primary`,
                            emit: `gotoSurgery`,
                            permission: `default`
                        }]
                        if (row.use_drug_apply_id > 0 && me.IsHavePermission(`use_drug_apply_delete`)) {
                            btns.push({
                                class: `is-plain`,
                                label: `删除`,
                                icon: ``,
                                type: `danger`,
                                emit: `deleteApply`,
                                permission: `default`
                            })
                        }
                        return btns
                    }
                }
            ]
        },
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { no: permissionNo }) != undefined
            }
        }
    },
    created() {
    },
    methods: {
        checkedRow({ row }) {
            this.checkedRows = row
        },
        runCarteServer() {
            let that = this
            console.log(that.checkedRows)
            if (that.checkedRows.length == 0) {
                return
            }
            if (that.useDrugApplyktr && that.useDrugApplyktr != `0`) {
                let ids = that.checkedRows.map(item => item.id).join(`,`)
                let str = `p=${that.currentUser.dic_worker_id}|${ids}`
                let req = this.myaxios.post(`/api/Anonymous/Carte/RunCarteServer?type=carte_UseDrugApply&paramStr=${str}`)
                req.then(data => {
                    this.$refs[`surgery_list`].ReloadListData()
                }).catch(e => {
                    console.log(e)
                })
            } else {
                this.$message.warning(`未配置carte文件，请确认！`)
            }
        },
        loadSurgeries2() {
            this.searchKey2 = this.substringcdata(this.searchKey2)
            this.searchKey = this.searchKey2
            this.$refs[`surgery_list`].ReloadListData()
        },
        substringcdata(inputval) {
            let outval = ``
            if (this.surgerSubStringRule != ``) {
                let rulestr = this.surgerSubStringRule.split(`,`)
                let left = rulestr[0]
                let right = rulestr[1]
                if (left == 0 && right != 0) {
                    outval = inputval.substring(0, right)
                } else if (left != 0 && right != 0) {
                    outval = inputval.substring(left, right)
                } else {
                    outval = inputval
                }
            } else {
                outval = inputval
            }
            return outval
        },
        loadSurgeries(resolve, reject) {
            // 加载可用模板
            let that = this
            // 更改日期触发更新列表
            let operatingWardId = 0
            let operatingRoomId = 0

            if (that.active_ward && _.startsWith(that.active_ward.value, `ow_`)) {
                operatingWardId = that.active_ward.origion || 0
                operatingRoomId = that.dic_room_id || 0
            }
            // 选复苏室则只看在当前复苏室的患者
            if (that.active_ward && _.startsWith(that.active_ward.value, `rw_`)) {
                operatingWardId = 0
                operatingRoomId = 0
            }
            let paras = {}
            paras.begin = that.rdate[0]
            paras.end = that
                .$moment(that.rdate[1])
                .add(1, `days`)
                .format(`YYYY/MM/DD`)
            paras.surgery_status = that.surgery_status
            paras.dic_operating_ward_id = operatingWardId
            paras.dic_operating_room_id = operatingRoomId
            paras.searchKey = that.searchKey
            let req = that.myaxios.post(`/api/AcisSystem/UseDrugApply/GetSurgeries`, paras)
            req.then(data => {
                resolve(data)
            }).catch(e => reject(e))
        },
        gotoSurgery({ row }) {
            console.log(this.business)
            let menuName = `apply_drugs`
            let r = _.find(this.business, t => {
                return t.business_level == `M003` && t.location == menuName
            })
            if (!r) {
                this.$message.error(`患者管理没有配置 ${menuName} 页面,请配置菜单和工作栏`)
            } else {
                let menuInfo = _.cloneDeep(r)
                this.openUrl(menuInfo, row)
            }
        },
        deleteApply({ row }) {
            console.log(row)
            let that = this
            let req = this.myaxios.delete(`/api/AcisSystem/UseDrugApply/Delete?surgeryId=${row.id}`)
            req.then(data => {
                that.$message.success(`用药申请已删除！`)
                that.$refs[`surgery_list`].ReloadListData()
            }).catch(e => console.log(e))
        },
        openUrl(menuInfo, surgery) {
            let that = this
            console.log(menuInfo)
            let url = (menuInfo && menuInfo.url) || `/`
            // 第三方链接直接弹框打开，不用二次弹框打开
            if (url.indexOf(`source=`) > -1) {
                url = decodeURIComponent(url.split(`source=`)[1])
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${surgery.id}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                this.windowOpenUrl(surgery.id, url)
            } else {
                // 本系统页面链接，直接调用患者管理路由加载界面
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${surgery.id}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                let routeUrl = this.$router.resolve({
                    path: url
                })
                var w = this.screenWidth - 10
                var h = this.screenHeight - 10
                that.newWindow = window.open(routeUrl.href, ``, `width=${w},height=${h},top=10,left=10`)
                if (!that.windowsOpenLoop) {
                    that.windowsOpenLoop = setInterval(() => {
                        if (that.newWindow.closed) {
                            clearInterval(that.windowsOpenLoop)
                            that.windowsOpenLoop = ``
                            that.$refs[`surgery_list`].ReloadListData()
                        }
                    }, 1000)
                }
            }
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`surgery_list`].ReloadListData()
        },
        surgery_status: function(newVlaue, oldValue) {
            this.$refs[`surgery_list`].ReloadListData()
        },
        active_ward: function() {
            this.$refs[`surgery_list`].ReloadListData()
        },
        dic_room_id: function() {
            this.$refs[`surgery_list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/UseDrugApply/Index.vue